import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import httpApiCall from "../service/api.service";
import { getProfileData, getStorageValue } from "../service/shared.service";
import toastr from "../components/elements/toast";

const AddDemoModal = (props: any) => {
  const toastrService = new toastr(true);
  const partnerData: any = getStorageValue("partnerData");
  const [changeInfo, setChangeInfo] = useState(1);
  const [type, setType] = useState(1);
  const [webEvents, setWebEvents] = useState<any>();
  const [timeZones, setTimeZones] = useState([]);
  const eventData = props.data;

  const [initialValues, setInitialvalues] = useState({
    topic: "",
    eventDate: "",
    time: "",
    link: "",
    timeZone: "",
    meetingID: "",
    passcode: "",
  });
  

  useEffect(() => {
    const data = eventData?.find(
      (item: any) =>
        item.event_type === changeInfo && item.child_event_type === type
    );

    setWebEvents(data);

    setInitialvalues({
      topic: data?.event_title || "",
      eventDate: data?.event_date || "",
      time: data?.event_time || "",
      link: data?.event_link || "",
      timeZone: data?.time_zone || "",
      meetingID: data?.meeting_id || "",
      passcode: data?.meeting_passcode || "",
    });
  }, [changeInfo, eventData, type]);

  const changeTab = (e: any) => {
    setChangeInfo(e);
  };
  const handleResetForm = (resetForm:any) => {
    resetForm();
    validationSchema.validate({}).then(() => {}).catch(errors => {
      errors.inner.forEach((err :any) => {
        resetForm.setFieldError(err.path, '');
      });
    });
  };
  const eventDateSchema = Yup.string().when([], (i, schema) =>(
    type == 1 && !initialValues.eventDate  ? schema.required("'Event date is required") : schema.notRequired()
  )).test(
    'is-valid-date',
    function (value) {
      if (!value) return true; // If value is empty, consider it as valid (Yup will handle required validation)
  
      // Helper function to parse and validate date from different formats
      const parseAndValidateDate = (value :any)  => {
        const dateParts = [
          { regex: /^(\d{2})\/(\d{2})\/(\d{4})$/, format: 'MM/dd/yyyy' }, // MM/dd/yyyy
          // { regex: /^(\d{2})-(\d{2})-(\d{4})$/, format: 'dd-MM-yyyy' }, // dd-MM-yyyy
          // { regex: /^(\d{4})\/(\d{2})\/(\d{2})$/, format: 'yyyy/MM/dd' } // yyyy/MM/dd
        ];
  
        for (let { regex, format } of dateParts) {
          const match = value.match(regex);
          if (match) {
            const [_, part1, part2, part3] = match;
            let dateObject;
            switch (format) {
              case 'MM/dd/yyyy':
                dateObject = new Date(part3, part1 - 1, part2);
                break;
              case 'dd-MM-yyyy':
                dateObject = new Date(part3, part2 - 1, part1);
                break;
              case 'yyyy/MM/dd':
                dateObject = new Date(part1, part2 - 1, part3);
                break;
              default:
                return null;
            }
  
            // Check if the constructed date matches the input parts
            const isValidDate =
              dateObject.getFullYear() === parseInt(part3) &&
              dateObject.getMonth() === (parseInt(part1) - 1 || parseInt(part2) - 1) &&
              dateObject.getDate() === (parseInt(part2) || parseInt(part1));
  
            return isValidDate ? dateObject : null;
          }
        }
        return null;
      };
  
      const dateObject = parseAndValidateDate(value);
      if (!dateObject) {
        return this.createError({ message: 'Invalid date format. Use MM/dd/yyyy' });
      }
      
      if (isNaN(dateObject.getTime())) {
        return this.createError({ message: 'Invalid date' });
      }
  
      // Check if the date is not in the past
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset today's date to midnight for comparison
      if (dateObject < today) {
        return this.createError({ message: 'Date cannot be in the past' });
      }
  
      return true; // Date is valid and not in the past
    }
  );
  
  const validationSchema = Yup.object().shape({
    topic: Yup.string().when([], (i, schema) => !initialValues.topic ? schema.required("Topic is required") : schema.notRequired()
    ),
    eventDate: eventDateSchema,

    time: Yup.string().when([], (i, schema) =>
      type == 1 && !initialValues.time ? schema.required("Time is required") : schema.notRequired()
    ),
    link: Yup.string().when([], (i, schema) => !initialValues.link
        ? schema.required("Link is required") : initialValues.link ? schema.url("Invalid URL format")
        : schema.notRequired()
    ),
    timeZone: Yup.string().when([], (i, schema) =>
      type == 1 && !initialValues.timeZone
        ? schema.required("Time Zone is required")
        : schema.notRequired()
    ),
    meetingID: Yup.string().when([], (i, schema) =>
      type == 1 && !initialValues.meetingID
        ? schema.required("Meeting ID is required")
        : schema.notRequired()
    ),
    passcode: Yup.string().when([], (i, schema) =>
      type == 1 && !initialValues.passcode ? schema.required("Passcode is required") : schema.notRequired()
    ),
  });
  useEffect(() => {
    fetchTrainingTimezones();
  }, []);

  const fetchTrainingTimezones = async () => {
    const body = {
      access_token: partnerData && partnerData?.access_token,
    };

    await httpApiCall({ api: "fetch_timezones", type: "post", body })
      .then((res) => {
        if (res.is_error == 0) {
          setTimeZones(res.data);
        } else {
          toastrService.showError("Event Not Added");
        }
      })
      .catch((error) => {
        console.log("Error in Register:", error);
      });
  };
  const handleSubmit = async (e: any) => {
    const data = timeZones.find((i: any) => i.val === e.timeZone);
    const baseBody = {
      event_title: initialValues.topic ? initialValues.topic :  e.topic,
      event_date: initialValues.eventDate ? initialValues.eventDate :e.eventDate,
      event_time: initialValues.time ? initialValues.time :e.time,
      time_zone: initialValues.timeZone ? initialValues.timeZone :e.timeZone,
      event_link: initialValues.link ? initialValues.link :e.link,
      event_type: changeInfo,
      child_event_type: type,
      alternate_daylight_code: data && data["alternate_daylight_code"],
      offset: data && data["offset"],
      name: data && data["name"],
      meeting_id: initialValues.meetingID ? initialValues.meetingID :e.meetingID,
      meeting_passcode: initialValues.passcode ? initialValues.passcode :e.passcode,
    };

    const body =
      webEvents && webEvents?.id
        ? {
            access_token: partnerData?.access_token,
            id: webEvents?.id,
            update: {
              ...baseBody,
            },
          }
        : type === 2
        ? {
            access_token: partnerData?.access_token,
            child_event_type: type,
            event_link: e.link,
            event_title: e.topic,
            event_type: changeInfo,
          }
        : {
            ...baseBody,
            access_token: partnerData?.access_token,
          };

    try {
      const res = await httpApiCall({
        api: `${
          webEvents && webEvents.id
            ? "updatePartnerEvent"
            : "savePartnerEventDetails"
        }`,
        type: "post",
        body,
      });

      setTimeZones(res.data);
      toastrService.showSuccess(
        webEvents && webEvents.id
          ? " Updated Successfully"
          : "Event Added Successfully"
      );
      props.onHide();
      getProfileData();
    } catch (error) {
      toastrService.showError("Event Not Added");
      console.log("Error in Register:", error);
    }
  };
  const formatDate = (inputValue :any) => {
    // Remove all non-numeric characters
    const cleanedValue = inputValue.replace(/\D/g, '');
  
    // Get the parts of the date (MM, DD, YYYY)
    const mm = cleanedValue.slice(0, 2);
    const dd = cleanedValue.slice(2, 4);
    const yyyy = cleanedValue.slice(4, 8);
  
    // Construct the formatted date string
    let formattedValue = '';
    if (mm) formattedValue += mm;
    if (dd) formattedValue += `/${dd}`;
    if (yyyy) formattedValue += `/${yyyy}`;
  
    return formattedValue;
  };

  const handleChange = (event: any) => {
    const { name, value ,selectionStart  } = event.target;
    const formattedValue = name === 'eventDate' ? formatDate(value) : value;

    if(name === 'eventDate'){
      // Get the difference in length between the original and formatted value
    const lengthDiff = formattedValue.length - value.length;

    // Calculate the new cursor position
    const newCursorPosition = selectionStart + lengthDiff;

    // Update the input field value with the formatted value
    event.target.value = formattedValue;

    // Adjust the cursor position
    event.target.setSelectionRange(newCursorPosition, newCursorPosition);

    }
    setInitialvalues({
      ...initialValues,
      [name]: formattedValue,
    });
  };
  const removeEvent = async () => {
    const body = {
      access_token: partnerData?.access_token,
      id: webEvents && webEvents.id,
    };
    try {
      const res = await httpApiCall({
        api: "deleteEvent",
        type: "post",
        body,
      });
      if (res) {
        toastrService.showSuccess("Training deleted Successfully");
        props.onHide();
        getProfileData();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="addWebstieModal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <div>
              <h1> Add Demo Details</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isValid, dirty, setFieldValue,resetForm  }) => (
                <Form>
                    <div className="d-flex align-items-center gap-4 mb-2">
            <div>
              <label htmlFor="web" className="label_input gap-3">
                <input
                  id="web"
                  type="radio"
                  name="website"
                  checked={type === 1}
                  onChange={() => {setType(1); handleResetForm(resetForm)}}
                />
                <label className="ms-1" htmlFor="web"> Website </label>
              </label>
            </div>
            <label htmlFor="Schedule" className="label_input gap-3" >
              <input
                id="Schedule"
                type="radio"
                name="website"
                onChange={() =>{ setType(2) ;handleResetForm(resetForm)}}
              />
              <label className="ms-1" htmlFor="Schedule"> Schedule Training </label>
            </label>
          </div>
          <div>
            {type == 2 && webEvents && webEvents.child_event_type == 2 && (
              <p
                onClick={removeEvent}
                className="text-danger text-end  cursor"
              >
                Remove Event
              </p>
            )}
          </div>
          <div>
            <ul
              className="tabs-wrapper-list mb-3"
              onClick={(e: any) => {changeTab(e.target.value) ; handleResetForm(resetForm)}}
            >
              <li value={1} className={changeInfo == 1 ? "bg-white" : ""}>
                For Business Website
              </li>
              <li value={2} className={changeInfo == 2 ? "bg-white" : ""}>
                For Partner Website
              </li>
            </ul>
          </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="" className="labels_input">
                          Topic*
                        </label>
                        <Field
                          className="form-control"
                          type="text"
                          name="topic"
                          value={initialValues.topic}
                          onChange={(e: any) => {
                            handleChange(e);
                            setFieldValue("topic", e.target.value);
                          }}
                        />
                      
                          {!initialValues.topic &&<ErrorMessage
                            name="topic"
                            className="text-danger m-2"
                            component={"small"}
                          />}

                      </div>
                    </div>
                    {type === 1 && (
                      <>
                        <div className="col-4">
                          <div className="form-group">
                            <label htmlFor="" className="labels_input">
                              Event Date*
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="eventDate"
                              placeholder="MM/DD/YYYY"
                                value={initialValues.eventDate}
                              onChange={(e: any) => {
                                  handleChange(e);
                                  setFieldValue("eventDate", e.target.value);
                                }}
                              />
                            <ErrorMessage
                              name="eventDate"
                              className="text-danger"
                              component={"small"}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label htmlFor="" className="labels_input">
                              Time*
                            </label>
                            <Field
                              className="form-control"
                              type="time"
                              name="time"
                              placeholder="HH:MM"
                              value={initialValues.time}
                              onChange={(e: any) => {
                                handleChange(e);
                                setFieldValue("time", e.target.value);
                              }}
                            />
                            <ErrorMessage
                              name="time"
                              className="text-danger m-2"
                              component={"small"}
                            />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label htmlFor="" className="labels_input">
                              Time Zone*
                            </label>
                            <Field
                              className="form-control"
                              as="select"
                              name="timeZone"
                              value={initialValues.timeZone}
                              onChange={(e: any) => {
                                handleChange(e);
                                setFieldValue("timeZone", e.target.value);
                              }}
                            >
                              <option value="">Select Time zone</option>
                              {timeZones &&
                                timeZones.map((timeZone: any, index: any) => (
                                  <option key={index} value={timeZone.val}>
                                    {timeZone.name}
                                  </option>
                                ))}
                            </Field>
                            <ErrorMessage
                              name="timeZone"
                              className="text-danger m-2"
                              component={"small"}
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group">
                            <label htmlFor="" className="labels_input">
                              Meeting ID*
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="meetingID"
                              value={initialValues.meetingID}
                              onChange={(e: any) => {
                                handleChange(e);
                                setFieldValue("meetingID", e.target.value);
                              }}
                            />
                            <ErrorMessage
                              name="meetingID"
                              className="text-danger m-2"
                              component={"small"}
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group">
                            <label htmlFor="" className="labels_input">
                              Passcode*
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="passcode"
                              value={initialValues.passcode}
                              onChange={(e: any) => {
                                handleChange(e);
                                setFieldValue("passcode", e.target.value);
                              }}
                            />
                            <ErrorMessage
                              name="passcode"
                              className="text-danger m-2"
                              component={"small"}
                            />
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="" className="labels_input">
                          Link*
                        </label>
                        <Field
                          className="form-control"
                          type="link"
                          name="link"
                          value={initialValues.link}
                          onChange={(e: any) => {
                            handleChange(e);
                            setFieldValue("link", e.target.value);
                          }}
                        />
                       
                          <ErrorMessage
                            name="link"
                            className="text-danger m-2"
                            component={"small"}
                          />
                      </div>
                    </div>
                  </div>
                  <div>
                    <button type="submit">Save</button>
                    <button className="ms-3">Preview</button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddDemoModal;
